"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.nodeType = exports.UiConfigSchema = exports.TaskSchema = void 0;
const zod_1 = require("zod");
const tape_sanitizer_1 = require("@finley-technologies/tape-sanitizer");
exports.TaskSchema = tape_sanitizer_1.AttachHeaderTransformationSchema.omit({
    srcDataTape: true,
}).extend({
    operation: zod_1.z.literal('attachHeader'),
    srcArtifactSlug: zod_1.z.string(),
});
exports.UiConfigSchema = exports.TaskSchema.omit({
    srcArtifactSlug: true,
});
exports.nodeType = 'operation_attachHeader';
//# sourceMappingURL=types.js.map